import { AddFramelessButton } from "./AddFramelessButton";
import { DetermineTextColor } from "./DetermineTextColor";
import { fontIconString } from "./fontIconString";
import { kExitChar, enumFontIconWeights } from "../constants";
import { uFramelessPanelColorDarker } from "../whitelabel/brand";

export function AddFramelessExitButton(parent) {
  var exitButton = AddFramelessButton(parent, kExitChar, "exitframeless", parent.fWidth - 20, 1);
  exitButton.fFontString = fontIconString(18, enumFontIconWeights.light);
  exitButton.fTxtFillStyle = DetermineTextColor(uFramelessPanelColorDarker);
  return exitButton;
}
